import { Component, inject, input, Output, EventEmitter } from '@angular/core';
import { IconComponent } from '../icons/icon.component';
import { OrderableCoupon } from '../../core/models/ordering/orderable-coupon.model';
import { IconNameType } from '../icons/icon-name-type.enum';
import { OrderService } from '../../core/services/order.service';
import { AccountCouponsService } from '../../core/services/account/account-coupons.service';
import { CommonModule } from '@angular/common';
import { EcommerceTriggeringArea } from '../../core/models/ecommerce/ecommerce-triggering-area.enum';
import { EcommerceTriggeringPoint } from '../../core/models/ecommerce/ecommerce-triggering-point.enum';
import { AuditService } from '../../core/services/audit.service';

@Component({
  selector: 'cwo-pending-special',
  standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './pending-special.component.html',
  styleUrl: './pending-special.component.scss',
})
export class PendingSpecialComponent {
  iconNameType = IconNameType;
  orderService = inject(OrderService);
  accountCouponsService = inject(AccountCouponsService);
  auditService = inject(AuditService)
  special = input.required<OrderableCoupon | undefined>();
  @Output() removed = new EventEmitter<void>();

  removeSpecial() {
    this.auditService.createAudit(() =>`'x' button clicked on coupon.` + (this.special() ? ` Name: ${this.special()?.name}` : ''));
    this.auditService.createAudit(() =>`Coupon successfully removed from order` + (this.special() ? ` Name: ${this.special()?.name}` : ''));
    if (this.removed.observed) {
      this.removed.emit();
      return;
    }
    if(this.special()){
      this.orderService.removePendingSpecial(this.special()?.name ?? '', EcommerceTriggeringPoint.REMOVE_SPECIAL_BUTTON, EcommerceTriggeringArea.ORDER_TREE).subscribe();
    } else {
      this.accountCouponsService.removeUnsubmittedCoupon();
    }
  }
}
